module.exports = __webpack_public_path__ + "static/media/platform_1.15a9ae8f.svg";